import { render, staticRenderFns } from "./SuggestedActions.vue?vue&type=template&id=6c60b8b3&scoped=true&"
import script from "./SuggestedActions.vue?vue&type=script&lang=ts&"
export * from "./SuggestedActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60b8b3",
  null
  
)

export default component.exports